/* Yen Aura · global optimistic cart drawer (24 Sep 2026 speed pass)
   ---------------------------------------------------------------
   assets/product-form.js covers the PDP, because those buy buttons sit inside a
   <product-form> element. The landing pages do NOT: each has its own
   <form action="/cart/add"> driven by lp-*.js, so they never got the benefit.

   Rather than edit every landing page script, this listens for ANY submit of a
   cart/add form in the capture phase and opens the drawer immediately, dimmed,
   while whatever script owns that form does the real work. It is purely
   additive: it adds a CSS class and calls the drawer's own open() method. If
   anything here throws, the page behaves exactly as it did before.

   The pending state is cleared as soon as the drawer's contents change, with an
   8s timeout as a backstop so the drawer can never be left stuck dimmed. */
(function () {
  'use strict';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function clearPending(d) {
    try { d.classList.remove('yen-pending'); } catch (e) {}
  }

  document.addEventListener(
    'submit',
    function (e) {
      try {
        var f = e.target;
        if (!f || typeof f.matches !== 'function') return;
        if (!f.matches('form[action*="/cart/add"]')) return;
        // The PDP path is already handled inside product-form.js.
        if (f.closest && f.closest('product-form')) return;

        var d = drawer();
        if (!d || typeof d.open !== 'function') return;
        if (d.classList.contains('active')) return;

        d.classList.add('yen-pending');
        d.open();
        setTimeout(function () { clearPending(d); }, 8000);
      } catch (err) {
        /* non-fatal: the original flow is untouched */
      }
    },
    true
  );

  /* Skeleton handling. Driven entirely off the yen-pending class so it works
     for BOTH entry points: product-form.js on the PDP and the generic submit
     listener above for the landing pages. Neither needs to know about this. */
  function showSkeleton(d) {
    try {
      if (d.querySelector('.yen-skel')) return;
      var host = d.querySelector('cart-drawer-items') || d.querySelector('.drawer__inner');
      if (!host) return;
      var s = document.createElement('div');
      s.className = 'yen-skel';
      s.setAttribute('aria-hidden', 'true');
      s.innerHTML =
        '<div class="yen-skel-row"><span class="yen-skel-img"></span>' +
        '<span class="yen-skel-lines"><i></i><i></i></span></div>';
      host.appendChild(s);
    } catch (e) {}
  }

  function removeSkeleton(d) {
    try {
      var s = d.querySelectorAll('.yen-skel');
      for (var i = 0; i < s.length; i++) s[i].remove();
    } catch (e) {}
  }

  // Drop the dimmed state the moment real cart content is swapped in.
  function watch() {
    var d = drawer();
    if (!d || d.__yenWatched) return;
    d.__yenWatched = true;
    try {
      // Wait for REAL cart content before dropping the loading state.
      // Clearing on the first DOM mutation was too eager: renderContents()
      // rewrites the drawer in stages, and an intermediate state can still be
      // the empty panel, which flashed "your cart is empty" for a frame or two
      // right before the items appeared. Only a rendered .cart-item (or the
      // drawer losing is-empty) means the content is actually there.
      new MutationObserver(function () {
        if (!d.classList.contains('yen-pending')) return;
        var hasContent =
          d.querySelector('.cart-item') || !d.classList.contains('is-empty');
        if (hasContent) {
          clearPending(d);
          removeSkeleton(d);
        }
      }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

      // Show or tear down the skeleton purely in response to the pending class.
      new MutationObserver(function () {
        if (d.classList.contains('yen-pending')) showSkeleton(d);
        else removeSkeleton(d);
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
